module.exports = __webpack_public_path__ + "img/lookup4.191096da.png";